module.exports = __webpack_public_path__ + "static/farmyardmain-17f2e71383a3369fbc26070568d33c56.png";